import { atom, useAtom, getDefaultStore } from 'jotai'

const urlFormValuesAtom = atom(null)

const useUrlFormValues = () => useAtom(urlFormValuesAtom)

export const getUrlFormValues = () => getDefaultStore().get(urlFormValuesAtom)

export default useUrlFormValues
